import apiClient from './apiClient'

export interface Workspace {
  id: string
  userId: string
  name?: string | null
  taxYear?: number
  taxYearStart?: string
  taxYearEnd?: string
  status?: string
  createdAt?: string
  updatedAt?: string
  metadata?: {
    completedQuestionnaire?: boolean
    hasIncomeEntries?: boolean
    hasCryptoTransactions?: boolean
    hasDocuments?: boolean
    questionnaireAnsweredVisible?: number
    questionnaireTotalVisible?: number
    incomeEntryCount?: number
    documentCount?: number
  }
  reviewSummary?: {
    readiness?: {
      score?: number
      status?: 'strong' | 'review_needed' | 'needs_attention'
    }
    warningCount?: number
    highSeverityWarningCount?: number
    warnings?: Array<{ code: string; severity: string; message: string }>
    assumptionCount?: number
  }
}

export const workspaceApi = {
  async list(): Promise<Workspace[]> {
    const response = await apiClient.get('/workspaces')
    return response.data?.items || []
  },

  async get(workspaceId: string): Promise<Workspace> {
    const response = await apiClient.get(`/workspaces/${workspaceId}`)
    return response.data?.workspace
  },

  async create(payload: { taxYearStart: string; taxYearEnd: string; name?: string }): Promise<Workspace> {
    const response = await apiClient.post('/workspaces', payload)
    return response.data?.workspace
  },

  async rename(workspaceId: string, name: string): Promise<Workspace> {
    const response = await apiClient.patch(`/workspaces/${workspaceId}`, { name })
    return response.data?.workspace
  },

  async remove(workspaceId: string): Promise<void> {
    await apiClient.delete(`/workspaces/${workspaceId}`)
  },
}
